import React, { Component } from 'react';
import { Suspense, lazy } from 'react';
import { Row } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';

import NavBar from './navBar';
import ProtectedRoute from '../common/protectedRoutes';
import UserContext from '../../context/userContext';
import { mobile } from './../../utils/constants';
import { getMyData } from '../../services/userService';
import { addDays } from './../../utils/commonFunctions';
import { warning } from '../common/toast';
import Chat from './Chat';
import './css/style.scss';
import './css/darkmode.scss';
import './css/4k.scss';
import './css/1024p.scss';
import './css/768p.scss';
import './css/mobile.scss';
import '../users/css/style.scss';
import '../security/css/style.scss';

import AnomalyPage from './anomaly';
import SummaryPage from '../summary/summary';
// const SecurityPage = lazy(() => import('../security/security'));
const UsersPage = lazy(() => import('../users/users'));
const UsersForm = lazy(() => import('../users/usersForm'));
const MyInfoPage = lazy(() => import('../user-info/me'));
// const CustomReport = lazy(() => import('../create-report/report'));
const KpiPage = lazy(() => import('../kpiview/kpiview'));
const FaqsPage = lazy(() => import('../faqs/faqsPage'));
const RootcausePage = lazy(() => import('../rootcause/rootcausePage'));
const UsageReport = lazy(() => import('../usage-report/report'));
const MobileTheme = lazy(() => import('../../utils/theme/mobileTheme'));

class LandingPage extends Component {
  state = {
    user: {},
    apiFailure: false,
    login: {
      //setting offline entry
      ip: '0.0.0.0',
      city: 'Unknown',
      region: 'Unknown',
      country: 'Unknown',
      date: new Date().toLocaleDateString(),
      time: new Date().toLocaleTimeString()
    }
  };

  expiryalert = (user) => {
    const expiry = new Date(user.expires_on + 'Z');
    const gap = expiry.getTime() - new Date().getTime();
    const difference = Math.floor(gap / 1000 / 60 / 60 / 24);
    if (expiry < addDays(new Date(), 3)) {
      let check = sessionStorage.getItem('expired');
      !check &&
        setTimeout(() => {
          warning(
            <>
              Your password expires in {difference} days. Reset it now.{' '}
              <a href='/me#password'>click here </a>
            </>
          );
        }, 3000);
      sessionStorage.setItem('expired', 'yes');
    }
  };
  async componentDidMount() {
    try {
      let { data: user } = await getMyData();
      //converting date from UTC to IST
      this.expiryalert(user);
      let login = JSON.parse(localStorage.getItem('security'));
      if (!login || login === undefined) this.setState({ user });
      else this.setState({ user, login });
    } catch (err) {
      this.setState({ apiFailure: true });
    }
  }

  render() {
    const { location } = this.props;
    const { pathname } = location;
    const RedirectHome = pathname && pathname === '/' && (
      <Redirect exact from='/' to='/home' />
    );
    let { user, apiFailure } = this.state;
    let usercheck = Object.keys(user).length > 0;

    const NotFound = pathname &&
      pathname !== '/' &&
      pathname !== '/home' &&
      pathname !== '/alerts' &&
      pathname !== '/dashboard' &&
      !pathname.includes('/rootcause/') &&
      !pathname.includes('/users') &&
      pathname !== '/usage-report' &&
      pathname !== '/faqs' &&
      pathname !== '/me' && <Redirect to='/not-found' />; //set in App.js

    const pages = [
      {
        path: '/alerts',
        component: AnomalyPage
      },
      {
        path: '/dashboard',
        component: KpiPage
      },
      {
        path: '/users/:id',
        component: UsersForm
      },
      {
        path: '/users',
        component: UsersPage
      },
      {
        path: '/me',
        component: MyInfoPage
      },
      {
        path: '/rootcause/:id',
        component: RootcausePage
      },
      {
        path: '/usage-report',
        component: UsageReport
      },
      {
        path: '/faqs',
        component: FaqsPage
      }
    ];

    return (
      <UserContext.Provider value={this.state}>
        {usercheck && (
          <Row className='vh-100' style={{ overflow: 'hidden' }}>
            <NavBar value={user} />

            {/* Routes code starts */}
            <ProtectedRoute
              path='/home'
              user={user}
              exact
              render={(props) => <SummaryPage {...props} />}
            />
            {pages.map((page, index) => {
              return (
                <ProtectedRoute
                  path={page.path}
                  user={user}
                  key={index}
                  exact
                  render={(props) => (
                    <Suspense fallback={<div></div>}>
                      <page.component {...props} />
                    </Suspense>
                  )}
                />
              );
            })}
            {RedirectHome}
            {NotFound}
            {/* Routes code exits */}
          </Row>
        )}
        {apiFailure && (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: this.props.location }
            }}
          />
        )}

        {/* Mobile theme import */}
        <React.Suspense fallback={<></>}>
          {mobile && <MobileTheme />}
        </React.Suspense>
      </UserContext.Provider>
    );
  }
}

export default LandingPage;
